import { Dialog } from "quasar";
import { i18n } from "@core/plugins/i18n";
import { JavascriptHelpers } from "@core/helpers";
import { h, resolveComponent } from "vue";

export class ConfirmLeaveComponentFactory {
  /**
   * Returns a simple vue-router component with a guarded leave behavior that will ask the user if he's sure he wants to exit the page
   * @param {Object} config
   * @property {Array} notGuardedTo - list of route names not to guard
   * @returns Vue component
   */
  static create({ notGuardedTo = [] } = {}) {
    return {
      async beforeRouteLeave(to, from, next) {
        if (this.shouldntGuardTo(to.name)) {
          return next();
        }

        try {
          await ConfirmLeaveComponentFactory.askForConfirmation();
          next();
        } catch (error) {
          next(false);
        }
      },
      methods: {
        shouldntGuardTo(routeName) {
          return notGuardedTo.includes(routeName);
        },
      },
      render() {
        return h(resolveComponent("router-view"));
      },
    };
  }

  static askForConfirmation() {
    return new Promise((resolve, reject) => {
      Dialog.create({
        class: "extracadabra-dialog extracadabra-dialog-warning",
        title: " ", // empty title for style
        message: JavascriptHelpers.insertWhitespaceBeforePunctuation(i18n.global.t("CORE.COMPONENTS.GUARDED_ROUTE.@ARE_YOU_SURE")),
        ok: {
          label: i18n.global.t("CORE.COMPONENTS.GUARDED_ROUTE.@EXIT"),
          color: "secondary",
          noCaps: true,
        },
        cancel: {
          label: i18n.global.t("CORE.COMPONENTS.GUARDED_ROUTE.@STAY"),
          noCaps: true,
          flat: true,
        },
        persistent: true,
      })
        .onOk(() => resolve())
        .onCancel(() => reject());
    });
  }
}
